import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';
import { ProgressStatus } from 'my-account/constants';
import { Cloudinary } from 'services/cloudinary';
@Component({
    selector: 'xm-addon-loader',
    templateUrl: './xm-addon-loader.html',
    styleUrls: ['./xm-addon-loader.scss'],
    standalone: false
})
export class XmAddonLoaderComponent implements OnChanges {
    @Input() public percentage: number;
    @Input() public pageData: CmsLoaderContent;
    @Input() public intent: string;
    @Input() public overallStatus: string;

    public emailIcon: MediaImageOptions;
    public isPending: boolean = false;
    public isSuccess: boolean = false;

    constructor(addonsUtil: AddonsUtil) {
        Object.assign(this, { addonsUtil });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.pageData?.currentValue && changes.pageData.currentValue.disclaimerIcon) {
            this.emailIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData?.disclaimerIcon)
            };
        }
        if (changes?.overallStatus?.currentValue) {
            this.isPending = this.overallStatus === ProgressStatus.PENDING;
            this.isSuccess = this.overallStatus === ProgressStatus.SUCCESS;
        }
    }
}
